<template>
    <div class="dp-fx fx-al-ct fx-js-ct br-rd-pr-50 twitter-share-bttn wd-ht-px-50 cs-ptr fz-20">
        <ShareNetwork
            :network="data.network"
            :url="data.url"
            :title="data.title"
            :description="data.description"
            :hashtags="data.hashtags"
            :twitterUser="data.twitterUser"
        >
            <font-awesome-icon :icon="data.icon"/>
        </ShareNetwork>
    </div>
</template>

<script>
    export default {
        name : 'TwitterShareButton',
        props : {
            data : Object
        }
    }
</script>

<style lang="scss">
    .wd-ht-px-60{
        width: 60px;
        height: 60px;
    }
    .wd-ht-px-50{
        width: 50px;
        height: 50px;
    }
    .twitter-share-bttn{
        background-color: #a6a6a6;
        color: #ffffff;
    }
</style>